import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { PaymentsTab } from "@/pages/admin/PaymentsTab";

const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export default function RefereePayments() {
  const today = new Date();
  const monthAgo = new Date(); monthAgo.setDate(monthAgo.getDate() - 30);
  const [paymentsRange, setPaymentsRange] = useState({ start: fmt(monthAgo), end: fmt(today) });
  const [payments, setPayments] = useState(null);
  const [paymentsBusy, setPaymentsBusy] = useState(false);
  const loadPayments = async () => {
    setPaymentsBusy(true);
    try { const { data } = await api.get("/admin/referee-payments", { params: paymentsRange }); setPayments(data); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setPaymentsBusy(false); }
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="referee-payments-page">
      <div className="mb-6">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Finance</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-1">Referee Payments</h1>
      </div>
      <PaymentsTab hideFees paymentsRange={paymentsRange} setPaymentsRange={setPaymentsRange} loadPayments={loadPayments} paymentsBusy={paymentsBusy} payments={payments} />
    </div>
  );
}
